import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconBookmarkMinus",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, l, f, _, a) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--bookmark-minus"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Bookmark Minus",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...r[0] || (r[0] = [
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.5 2a.5.5 0 0 0-.5.5v7.138l2.752-1.572a.5.5 0 0 1 .496 0L9 9.638V2.5a.5.5 0 0 0-.5-.5h-5Zm-1.06-.56A1.5 1.5 0 0 1 3.5 1h5A1.5 1.5 0 0 1 10 2.5v8a.5.5 0 0 1-.748.434L6 9.076l-3.252 1.858A.5.5 0 0 1 2 10.5v-8c0-.398.158-.78.44-1.06Z",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 4 5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const k = /* @__PURE__ */ s(c, [["render", m]]);
export {
  k as default
};
//# sourceMappingURL=bookmark-minus.js.map
